module.exports = {"530626101":"中城镇","530626102":"南岸镇","530626103":"新滩镇","530626104":"会仪镇","530626105":"板栗镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530626.json
// module id = 2720
// module chunks = 0